define('formkit/view/block/section.dropdown.view',['require','exports','module','uikit/uikit','../../behavior/go.to.selected.section.on.event.behavior'],function(require, exports, module) {
  var UIKit                              = require('uikit/uikit');
  var GoToSelectedSectionOnEventBehavior = require('../../behavior/go.to.selected.section.on.event.behavior');


  var SectionDropdownView = UIKit.Dropdown.extend({

    childBindings: { text: 'text' },

    behaviors: {
      GoToSelectedSectionOnEventBehavior: {
        eventName: 'childview:press',
        behaviorClass: GoToSelectedSectionOnEventBehavior
      }
    },

    initialize: function() {
      UIKit.Dropdown.prototype.initialize.apply(this, arguments);

      if (this.form) {
        var form = this.form;
        var allSections = this.form.getTemplateModel().get('children');
        var filteredSections = allSections.filter(function(section) {
          return form.util.isVisible(section);
        });

        this.collection = new Backbone.Collection();
        this.collection.set(filteredSections);
        this.value = this.form.getActiveSectionModel();
      }

      this.listenTo(this.form, 'change:activeSectionModel', function(newActiveSectionModel) {
        this.value = newActiveSectionModel;
      })
    }
  });
  module.exports = SectionDropdownView;
});

